var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 62,
  height: 60,
  viewBox: "0 0 62 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.73 20.243V60H1.68V20.243zm34.18-1.537c8.903 0 13.988 5.75 14.09 18.08v23.21H49.974V38.63c0-5.48-1.973-9.221-6.908-9.221-3.767 0-6.01 2.521-6.996 4.957-.36.873-.628 2.072-.628 3.291v22.34H21.654v-.095c.005-1.003.048-9.795.068-18.87l.004-1.704.006-4.491.001-1.094v-2.647c-.003-5.318-.024-9.58-.08-10.767h13.968v5.113c1.81-2.777 5.05-6.736 12.29-6.736M7.713 0c4.664 0 7.536 3.046 7.625 7.046 0 3.916-2.961 7.05-7.715 7.05h-.087C2.96 14.096 0 10.962 0 7.046 0 3.046 3.05 0 7.713 0"
})));
export default SvgChannelLinkedin;